export default __webpack_public_path__ + "static/media/46.e80faf87.png";